<template>
  <v-app>
    <Navbar>
      <v-app-bar-nav-icon
        v-if="hasCompany"
        class="hidden-lg-and-up"
        @click="drawer = !drawer"
      ></v-app-bar-nav-icon>
    </Navbar>
    <v-navigation-drawer v-if="signedIn && hasCompany" v-model="drawer" app>
      <NavDrawer />
    </v-navigation-drawer>
    <v-main style="background-color: #f5f7fa">
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import "@/firebase/init";
import Navbar from "./components/Navigation/Navbar";
import NavDrawer from "./components/Navigation/NavDrawer";

export default {
  name: "App",
  components: {
    Navbar,
    NavDrawer,
  },
  data: () => ({
    drawer: true,
  }),
  computed: {
    signedIn() {
      return this.$store.state.firUser != null;
    },
    hasCompany() {
      return Object.keys(this.$store.state.companies).length > 0;
    },
  },
};
</script>
